import React from 'react';
import { portfolioData } from '../mockData';

const Footer = () => {
  const { personal } = portfolioData;

  return (
    <footer>
      <span>© {new Date().getFullYear()} {personal.name}</span>
      <a href={`mailto:${personal.email}`}>{personal.email}</a>
    </footer>
  );
};

export default Footer;
